var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.visibleProxy,
        title: _vm.isEdit ? "Chỉnh sửa gói giới hạn" : "Thêm gói giới hạn",
        width: "520px",
        "close-on-click-modal": false,
        "append-to-body": "",
        "custom-class": "ps-dialog",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visibleProxy = $event
        },
      },
    },
    [
      _c("div", { staticClass: "ps-dialog-intro" }, [
        _c("div", { staticClass: "ps-dialog-intro__icon" }, [
          _c("i", { staticClass: "el-icon-box" }),
        ]),
        _c("div", [
          _c("h3", [
            _vm._v(
              _vm._s(
                _vm.isEdit
                  ? "Cập nhật thông tin gói"
                  : "Tạo gói mới cho hệ thống"
              )
            ),
          ]),
          _c("p", [
            _vm._v(
              "Giới hạn được tính theo số học sinh đang học tại mỗi trường. Mã gói sẽ do hệ thống tự sinh."
            ),
          ]),
        ]),
      ]),
      _c(
        "el-form",
        {
          ref: "packageForm",
          staticClass: "ps-dialog-form",
          attrs: { model: _vm.form, rules: _vm.rules, "label-position": "top" },
        },
        [
          _vm.isEdit
            ? _c(
                "el-form-item",
                { attrs: { label: "Mã gói" } },
                [
                  _c(
                    "el-input",
                    { attrs: { value: _vm.editingPackage.code, disabled: "" } },
                    [
                      _c("i", {
                        staticClass: "el-icon-price-tag",
                        attrs: { slot: "prefix" },
                        slot: "prefix",
                      }),
                    ]
                  ),
                  _c("span", { staticClass: "ps-form-hint" }, [
                    _vm._v(
                      "Mã gói được backend sinh tự động và không thể chỉnh sửa."
                    ),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            { attrs: { label: "Tên gói", prop: "name" } },
            [
              _c("el-input", {
                attrs: {
                  maxlength: "80",
                  "show-word-limit": "",
                  clearable: "",
                  placeholder: "VD: Gói Phát triển",
                },
                model: {
                  value: _vm.form.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "name", $$v)
                  },
                  expression: "form.name",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "Số giới hạn học sinh", prop: "limit" } },
            [
              _c("el-input-number", {
                staticClass: "ps-full-width",
                attrs: { min: 1, max: 100000, "controls-position": "right" },
                model: {
                  value: _vm.form.limit,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "limit", $$v)
                  },
                  expression: "form.limit",
                },
              }),
              _c("span", { staticClass: "ps-form-hint" }, [
                _vm._v(
                  "Chỉ nhận số nguyên dương. Add-on sẽ được cộng riêng tại từng trường."
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "ps-dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.visibleProxy = false
                },
              },
            },
            [_vm._v("Hủy")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.saving },
              on: { click: _vm.handleConfirm },
            },
            [
              _c("i", { staticClass: "el-icon-check" }),
              _vm._v(
                " " + _vm._s(_vm.isEdit ? "Lưu thay đổi" : "Tạo gói") + "\n    "
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }